var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.Is,{ref:"field",tag:"component",attrs:{"value":_vm.Data,"config":_vm.config,"options":_vm.options,"is-loading":_vm.isLoading,"is-end":_vm.isEnd},on:{"change":_vm.handleChange,"load":_vm.handleLoad}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }